import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENV_CONFIG } from '../../environments/environment.config';
import { LoginRequest, LoginResponse, RefreshTokenRequest, RefreshTokenResponse } from '../types/auth.model';

@Injectable({
  providedIn: 'root'
})
export class AuthHttpService {
  private http = inject(HttpClient);
  private readonly BASE = ENV_CONFIG.api.auth;
  private readonly LOGIN_ENDPOINT = `${this.BASE}${ENV_CONFIG.endpoints.auth.login}`;
  private readonly LOGOUT_ENDPOINT = `${this.BASE}${ENV_CONFIG.endpoints.auth.logout}`;
  private readonly INVALIDATE_SESSION_ENDPOINT = `${this.BASE}${ENV_CONFIG.endpoints.auth.invalidateSession}`;
  private readonly REFRESH_TOKEN_ENDPOINT = `${this.BASE}${ENV_CONFIG.endpoints.auth.refreshToken}`;

  login(request: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(this.LOGIN_ENDPOINT, request);
  }

  logout(sessionId: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(this.LOGOUT_ENDPOINT, {sessionId});
  }

  invalidatePreviousSession(userId: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(this.INVALIDATE_SESSION_ENDPOINT, { userId, forceInvalidate: true });
  }

  refreshToken(sessionId: string, refreshToken: string): Observable<RefreshTokenResponse> {
    const request: RefreshTokenRequest = { sessionId, refreshToken };
    return this.http.post<RefreshTokenResponse>(this.REFRESH_TOKEN_ENDPOINT, request);
  }
}
